import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TimePriceForm, TimePriceFormProps, Dialog } from "@components";

// Interface for Modal props, extending Form props and adding modal controls
export interface TimePriceModalProps extends Omit<
  TimePriceFormProps,
  "onCancel"
> {
  show: boolean;
  onClose: () => void;
  // onConfirm is inherited from TimePriceFormProps
}

export const TimePriceModal: FC<TimePriceModalProps> = ({
  show,
  onClose,
  onConfirm,
  initialPrice,
  initialVat,
  initialTimePeriod,
}) => {
  const { t } = useTranslation(["common"]);

  return (
    <Dialog
      show={show}
      toggleModal={onClose} // Use onClose for toggling visibility
      title={t("common:time_price_button")}
      hideButtons // Hide default Dialog buttons, form has its own
      dismissible // Allow closing by clicking outside
      content={
        // Pass relevant props down to the form
        <TimePriceForm
          initialPrice={initialPrice}
          initialVat={initialVat}
          initialTimePeriod={initialTimePeriod}
          onConfirm={onConfirm}
          onCancel={onClose} // Form's cancel button triggers modal close
        />
      }
    />
  );
};
